<div class="chemistry card">
    <div class="chemistry__button-section">
        <i class="button-section__icon fa-regular fa-flask-gear" [ngClass]="{ 'button-section__icon_disabled': isDisabled(78) }"></i>
        <button class="button button_with-icon button_type_underline button_theme_main-line" (click)="editServices()" [disabled]="isDisabled(78)">
            <span>עריכת סוגי כימיה</span>
        </button>
    </div>

    <p-dataView
        *ngIf="state == 'loaded' && cardscolor && !cardscolor[0].lastDeleted"
        class="chemistry__dataview custom-scrollbar"
        [value]="cardscolor"
        [rows]="30"
        layout="grid"
    >
        <ng-template let-cardcolor pTemplate="gridItem">
            <div class="dataview__item-card">
                <div class="item-card__header">
                    <div class="header__right-section header__section">
                        <div class="right-section__avatar"><img src="assets/img/{{ cardcolor.iconName }}" /></div>
                        <div class="right-section__info">
                            <span class="right-section__name">{{ cardcolor.serviceName }}</span>
                            <div class="right-section__date-wrapper">
                                <i class="fa-regular fa-calendar-lines right-section__date-icon"></i>
                                <span class="right-section__date">{{ cardcolor.regDate }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="header__left-section header__section">
                        <i class="fa-regular fa-calendar-lines left-section__date-icon"></i>
                        <span class="left-section__date">{{ cardcolor.regDate }}</span>
                        <button
                            class="left-section__menu-button left-section__menu-button_desktop"
                            (click)="toggleSubMenu($event, menu, cardcolor, false)"
                        ></button>
                        <button
                            class="left-section__menu-button left-section__menu-button_mobile"
                            (click)="toggleSubMenu($event, menu, cardcolor, true)"
                        ></button>
                        <p-menu #menu class="header__menu action-list" [model]="attachmentItems" [popup]="true"></p-menu>
                    </div>
                </div>

                <div class="item-card__main">
                    <div class="main__section">
                        <div class="section__panel section__large-panel section__main-panel">
                            <span class="panel__name">חברות / צבעים</span>
                            <div class="panel__info">
                                <div class="custom-scrollbar">
                                    <span>{{ cardcolor.companies }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="section__panel section__small-panel section__main-panel">
                            <span class="panel__name">חמצנים</span>
                            <div class="panel__info">
                                <div class="custom-scrollbar">
                                    <span>{{ cardcolor.oxyGen }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="main__section">
                        <div class="section__panel section__large-panel">
                            <span class="panel__name">הנחיות/הערות/מחיר</span>
                            <div class="panel__info">
                                <div class="custom-scrollbar">
                                    <span>{{ cardcolor.comments }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="section__panel section__small-panel">
                            <span class="panel__name">זמן המתנה</span>
                            <div class="panel__info">
                                <div class="custom-scrollbar">
                                    <span>{{ cardcolor.description }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-dataView>

    <div *ngIf="state == 'nocardcolors' || (cardscolor && cardscolor[0].lastDeleted)" class="empty-dataview">
        <span class="empty-dataview__title">אין עדיין כרטיסי כימיה ללקוח/ה</span>
        <span class="empty-dataview__text">ליצירת כימיה חדשה לחץ על הכפתור פלוס הכחול שבתחתית המסך</span>
        <span class="empty-dataview__image"></span>
    </div>
</div>

<button class="button button_icon-only button_theme_main add-button" (click)="addNewCardColor()">
    <i class="fa-regular fa-plus"></i>
</button>

<p-dialog
    [ngClass]="{ 'custom-dialog': isDeletingCard }"
    styleClass="modal modal_type_confirm"
    [(visible)]="isDeletingCard"
    header="מחיקה"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <span class="modal__text">האם אתם בטוחים במחיקה?</span>
    <div class="modal__footer">
        <button class="button button_size_small button_theme_gray-line" (click)="cancelButton()">ביטול</button>
        <button class="button button_size_small button_theme_main" (click)="deleteCardColor(activeCardColor)">מחיקה</button>
    </div>
</p-dialog>

<p-dialog
    [ngClass]="{ 'custom-dialog': isCardMenuOpened }"
    styleClass="modal modal_type_menu modal_card-menu"
    [(visible)]="isCardMenuOpened"
    header="פעולות נוספות"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
    transitionOptions="0ms"
>
    <button
        *ngFor="let item of attachmentItems"
        class="menu-button {{ item.icon }} button button_with-icon"
        (click)="item.command()"
        [disabled]="item.disabled"
    >
        {{ item.label }}
    </button>
</p-dialog>

<p-messages class="messages"></p-messages>

<div
    appHostListenerBeforeUnload
    #hostListenerBeforeUnload="hostListenerBeforeUnload"
    (componentHasChangedOutput)="this.componentHasChanged = $event"
    [saveData]="saveData"
    [receivedData]="cardscolor"
></div>
